import {
    Button,
    Flex,
    FlexItem,
    BaseControl
} from '@wordpress/components';
import { SelectControl, TextControl } from '../../../components/fieldComponents';
import { __ } from '@wordpress/i18n';

const AdvancedSettingsTab = ({ conditionalLogic = [[]], conditionFieldOptions, onChange }) => {
    const updateConditionalLogic = (newLogic) => onChange('conditional_logic', newLogic);

    return (
        <>
            <p>{__('Display this field only if any of the following groups of conditions are met:', 'voxycure-framework')}</p>

            {conditionalLogic.map((group, groupIndex) => (
                <ConditionGroup
                    key={groupIndex}
                    group={group}
                    groupIndex={groupIndex}
                    conditionFieldOptions={conditionFieldOptions}
                    onChange={updateConditionalLogic}
                    conditionalLogic={conditionalLogic}
                />
            ))}

            <Button
                isSecondary
                isSmall
                icon="plus"
                onClick={() => updateConditionalLogic([...conditionalLogic, [{ field: '', operator: '==', value: '' }]])}
            >
                {__('Add New Condition Group', 'voxycure-framework')}
            </Button>
        </>
    );
};

const ConditionGroup = ({ group, groupIndex, conditionFieldOptions, onChange, conditionalLogic }) => (
    <div style={{ border: '1px solid #ddd', padding: '1rem', marginBottom: '1rem', borderRadius: '4px' }}>
        <h4>{__('Condition Group', 'voxycure-framework')} {groupIndex + 1}</h4>

        {group.map((condition, conditionIndex) => (
            <Condition
                key={conditionIndex}
                condition={condition}
                groupIndex={groupIndex}
                conditionIndex={conditionIndex}
                conditionFieldOptions={conditionFieldOptions}
                onChange={onChange}
                conditionalLogic={conditionalLogic}
            />
        ))}

        <Button
            isSecondary
            isSmall
            icon="plus"
            style={{ marginTop: '0.5rem' }}
            onClick={() => {
                const updated = [...conditionalLogic];
                updated[groupIndex].push({ field: '', operator: '==', value: '' });
                onChange(updated);
            }}
        >
            {__('Add Condition to Group', 'voxycure-framework')}
        </Button>
    </div>
);

const Condition = ({ condition, groupIndex, conditionIndex, conditionFieldOptions, onChange, conditionalLogic }) => (
    <BaseControl>
        <Flex gap={2}>
            <FlexItem style={{ flex: '0 0 35%' }}>
                <SelectControl
                    field={{
                        label: __('Field', 'voxycure-framework'),
                        options: [
                            { label: __('-- Select Field --', 'voxycure-framework'), value: '' },
                            ...conditionFieldOptions
                        ]
                    }}
                    value={condition.field}
                    onChange={(value) => {
                        const updated = [...conditionalLogic];
                        updated[groupIndex][conditionIndex].field = value;
                        onChange(updated);
                    }}
                />
            </FlexItem>

            <FlexItem style={{ flex: '0 0 20%' }}>
                <SelectControl
                    field={{
                        label: __('Operator', 'voxycure-framework'),
                        options: [
                            { label: __('Equals', 'voxycure-framework'), value: '==' },
                            { label: __('Not Equals', 'voxycure-framework'), value: '!=' }
                        ]
                    }}
                    value={condition.operator || '=='}
                    onChange={(value) => {
                        const updated = [...conditionalLogic];
                        updated[groupIndex][conditionIndex].operator = value;
                        onChange(updated);
                    }}
                />
            </FlexItem>

            <FlexItem style={{ flex: '0 0 30%' }}>
                <TextControl
                    field={{
                        label: __('Value', 'voxycure-framework'),
                        type: 'text'
                    }}
                    value={condition.value}
                    onChange={(value) => {
                        const updated = [...conditionalLogic];
                        updated[groupIndex][conditionIndex].value = value;
                        onChange(updated);
                    }}
                />
            </FlexItem>

            <FlexItem style={{ alignSelf: 'flex-end' }}>
                <Button
                    isSmall
                    isDestructive
                    icon="no"
                    onClick={() => {
                        const updated = [...conditionalLogic];
                        updated[groupIndex].splice(conditionIndex, 1);
                        if (updated[groupIndex].length === 0) {
                            updated.splice(groupIndex, 1);
                        }
                        onChange(updated);
                    }}
                />
            </FlexItem>
        </Flex>
    </BaseControl>
);

export default AdvancedSettingsTab;
